<template>
  <div id="start" style="width: 100vmin;height: 100vmax;" @click="startClick"
    class="d-flex jc-center ai-end img-container pl-32">
    <img class="to-right animate__animated animate__fadeInDown animate__infinite animate__delay-1s"
      src="../assets/img/toRight.png" />
  </div>
</template>

<script>

export default {
  name: "beforeStart",
  props: {
    verticalVisible: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
  components: {},
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {},
  methods: {
    startClick() {
      this.$emit("startClick", 'start');
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  }
};
</script>

<style lang="scss">
.to-right {
  height: 13.34vmin;
  width: 11vmin;
}

.img-container {
  width: 100vmin;
  height: 100vmax;
  // opacity: 0.4;
  // animation: fadeIn 2s forwards;
  background-image: url("../assets/img/poster.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #7fe1ee;
}
</style>



// WEBPACK FOOTER //
// src/view/beforeStart.vue